import React from 'react';
import { AssetIcon } from '../../assets';
import { useIconActions } from '../IconActions';
import IconAction from '../IconAction';

export default function PrimaryActionButton({
  children,
  iconKey = 'actions.add',
  tone = 'default',
  type = 'button',
  disabled = false,
  loading = false,
  loadingLabel,
  onClick,
  className = '',
  ...buttonProps
}) {
  const iconOnly = useIconActions();
  const isDisabled = disabled || loading;
  if (iconOnly) return <IconAction {...buttonProps} type={type} iconKey={iconKey || undefined}
    tone={tone} disabled={isDisabled} aria-busy={loading || buttonProps['aria-busy']}
    onClick={onClick} className={className}>
    {loading && loadingLabel ? loadingLabel : children}
  </IconAction>;

  return (
    <button
      {...buttonProps}
      type={type}
      className={['wt-primary-action-button', `wt-primary-action-button--${tone}`, className].filter(Boolean).join(' ')}
      disabled={isDisabled}
      aria-busy={loading ? true : buttonProps['aria-busy']}
      onClick={onClick}
    >
      {iconKey ? <AssetIcon name={iconKey} size={16} /> : null}
      <span>{loading && loadingLabel ? loadingLabel : children}</span>
    </button>
  );
}
